module.exports = __webpack_public_path__ + "static/terms-and-conditions-00beeb254d03c329a0101af057aac917.jpg";